import Keycloak from 'keycloak-js';
import { isProd, isStage } from './constants/config';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  url: isProd
    ? 'https://login.apgsga.ch/auth/'
    : isStage
      ? 'https://login-t1.apgsga.ch/auth/' // APG-906: Switch over Stage to auth on T1 as well, keep defaulting to T1.
      : 'https://login-t1.apgsga.ch/auth/',
  realm: 'apg',
  clientId: 'e-commerce',
});

if (!process.env.REACT_APP_MODE || process.env.REACT_APP_MODE !== 'django') {
  (window as any).keycloak = keycloak;
}

export default keycloak;
